import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import { products } from '../../data/mockData';

const FeaturedProductsSection = () => (
  <section className="py-16 md:py-24 bg-gradient-to-b from-[#f9fafb] to-white relative">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <div className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-50 border border-blue-200 rounded-full mb-4">
          <Lock className="h-4 w-4 text-blue-600" />
          <span className="text-blue-600 text-sm font-medium">Safety Solutions</span>
        </div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">Featured Products</h2>
        <p className="text-base md:text-xl text-gray-600 max-w-2xl mx-auto">
          Performance-driven guarding systems built to extend machine life and protect against dust, wear, and downtime
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {products.slice(0, 6).map((product, index) => (
          <Link
            key={product.id}
            to={`/products/${product.slug}`}
            className="group relative"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-2xl blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            <div className="relative bg-white border border-gray-200 rounded-2xl overflow-hidden hover:border-cyan-300 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl">
              <div className="aspect-video overflow-hidden bg-gradient-to-br from-gray-100 to-gray-50 relative">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-cyan-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute top-4 left-4">
                  <div className="px-3 py-1.5 bg-white/90 backdrop-blur-sm border border-cyan-200 rounded-full">
                    <span className="text-xs text-cyan-600 font-semibold">{product.category}</span>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-cyan-600 transition-colors line-clamp-2">
                  {product.name}
                </h3>
                <p className="text-gray-600 text-sm mb-6 line-clamp-2">{product.shortDescription}</p>
                <div className="flex items-center text-cyan-600 font-semibold">
                  <span className="text-sm">Learn More</span>
                  <ArrowRight className="h-4 w-4 ml-2 group-hover:translate-x-2 transition-transform duration-300" />
                </div>
              </div>

              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-1000" />
            </div>
          </Link>
        ))}
      </div>

      <div className="text-center mt-12">
        <Link to="/products" className="group relative inline-flex items-center space-x-2 px-8 py-4 rounded-xl font-semibold transition-all duration-300">
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-600 to-blue-600 rounded-xl blur-lg opacity-30 group-hover:opacity-50 transition-opacity" />
          <div className="relative flex items-center space-x-2 bg-gradient-to-r from-cyan-600 to-blue-600 text-white rounded-xl px-8 py-4 transform group-hover:scale-105 transition-all shadow-xl hover:shadow-2xl">
            <span>View All Products</span>
            <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </div>
        </Link>
      </div>
    </div>
  </section>
);

export default FeaturedProductsSection;
